import { createFeatureSelector } from '@ngrx/store';
import { rendersAdapter, State } from '../reducers/renders.reducer';

export const getRendersState = createFeatureSelector<State>('renders');

const { selectAll } = rendersAdapter.getSelectors(getRendersState);

export const selectAllRenders = selectAll;
